const DEFAULT_STATE_KEY = 'bradley_sidebar_state'
const DEFAULT_VISITED_KEY = 'bradley_sidebar_visited'

function safeGetItem(key) {
  try {
    if (globalThis.window === undefined) {
      return null
    }
    return globalThis.window.localStorage?.getItem(key) ?? null
  }
  catch {
    return null
  }
}

function safeSetItem(key, value) {
  try {
    if (globalThis.window === undefined) {
      return
    }
    globalThis.window.localStorage?.setItem(key, value)
  }
  catch {
  }
}

export function useBradleySidebarPersistence(options = {}) {
  const stateKey = options.stateKey ?? DEFAULT_STATE_KEY
  const visitedKey = options.visitedKey ?? DEFAULT_VISITED_KEY

  const initialExpanded = safeGetItem(stateKey) !== 'collapsed'

  const isFirstVisit = safeGetItem(visitedKey) !== 'true'

  function persistExpanded(expanded) {
    safeSetItem(stateKey, expanded ? 'expanded' : 'collapsed')
  }

  function markVisited() {
    safeSetItem(visitedKey, 'true')
  }

  return {
    initialExpanded,
    isFirstVisit,
    persistExpanded,
    markVisited,
  }
}
